import { cn } from '#/lib/utils';

export const Noise = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'pointer-events-none fixed inset-0 noise z-30 h-screen-l w-screen',
        className,
      )}
    />
  );
};
